import styled from "styled-components";
export const Padding = styled.div `
  box-sizing: border-box;
  padding: 12px 10px;
  max-height: 100%;
`;
